import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// import { Route } from "react-router-dom";

import TechCheck from '../pages/TechCheck';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import Home from '../pages/Home';
import PanelSegmentSelect from '../pages/PanelSegmentSelect/PanelSegmentSelect';
import ProcessTargetUrl from '../pages/ProcessTargetUrl';
import Logout from '../pages/Logout';
import Security from '../pages/Security';
import MPAAWarning from '../pages/MPAA';
import Study from '../pages/Study';
import MobileRedirect from '../pages/MobileRedirect';
import NotFound from '../pages/NotFound';
import Unavailable from '../pages/Unavailable';
import VideoDisclaimer from '../pages/VideoDisclaimer';
import ViewerConsentDisclaimer from '../pages/ViewerConsent';
import NonPartnerRestricted from '../pages/NonPartnerRestricted';

import Feedback from '../components/global/Feedback';
import GlobalHeader from '../components/global/GlobalHeader';
import AmazonAlidaHeader from '../components/global/AmazonAlidaHeader';
import AmazonQualtricsHeader from '../components/global/AmazonQualtricsHeader';

import * as auth from '../functions/auth';
import { setPanelPartner } from '../redux/actions/index';
import DeviceHelper from '../functions/device';

class UnauthedLayoutComponent extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		let { panelPartner } = this.props;
		let childrenWithProps = React.Children.map(this.props.children,
			(child) => React.cloneElement(child, {
				...this.props,
			})
		);

		let header;
		let backgroundColorClass = '';
		switch (panelPartner) {
			case 'alida': {
				header = <AmazonAlidaHeader />;
				backgroundColorClass = `ghost-bkgd ${DeviceHelper.isMobile ? " alida-layout" : ""}`;
				break;
			}
			case 'qualtrics': {
				header = <AmazonQualtricsHeader />;
				backgroundColorClass = `white-bkgd ${DeviceHelper.isMobile ? " qualtrics-layout" : ""}`;
				break;
			}
			default: {
				header = <GlobalHeader />;
			}
		}

		return (
			<div className={`pilotly-layout pilotly-unauthed-layout ${backgroundColorClass}`}>
				<div className={`pilotly-gradient ${backgroundColorClass}`}>
					{this.props.location && this.props.location.pathname.includes("login") ? 
						<div>
							{/* {settings.isDev ? 
								<LocaleButton {...this.props} />
								: ""
							} */}
						</div>
						: 
						header
					}
					{ childrenWithProps }
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		panelPartner: state.targetProcess.panelPartner
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({ setPanelPartner }, dispatch);
}

export const UnauthedLayout = connect(mapStateToProps, mapDispatchToProps)(UnauthedLayoutComponent);

export class AuthedLayout extends Component {

	componentWillMount() {
		if (auth.isAuthenticated() !== true) {
			<Redirect to={{
				pathname: '/login',
				state: { from: this.props.location }
			}} />;
		}
	}
	
	render() {
		let childrenWithProps = React.Children.map(this.props.children,
			(child) => React.cloneElement(child, {
				...this.props,
			})
		);

		return (
			<div className="pilotly-layout pilotly-authed-layout">
				<div className="pilotly-gradient">
					{/* <div><LocaleButton /></div> */}
					{childrenWithProps}
					{/*<Route path={this.props.match.url + 'register/'} component={RegisterLayout}/>*/}
				</div>
			</div>
		);
	}
}

export class TechCheckLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<TechCheck {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class LoginLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<Login {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class LogoutLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<Logout {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class RegisterLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<Register {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class ForgotPasswordLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<ForgotPassword {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class ResetPasswordLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<ResetPassword {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class ProcessTargetLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<ProcessTargetUrl {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class PanelSegmentSelectLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<PanelSegmentSelect {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class SecurityLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<Security {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class VideoDisclaimerLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<VideoDisclaimer {...this.props} />
			</UnauthedLayout>
		);
	}
}

export class ViewerConsentDisclaimerLayout extends Component {
	render() {
		return (
			<AuthedLayout location={this.props.location}>
				<ViewerConsentDisclaimer {...this.props} />
			</AuthedLayout>
		);
	}
}

export class UnavailableLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<Unavailable />
			</UnauthedLayout>
		);
	}
}

export class NotFoundLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<NotFound />
			</UnauthedLayout>
		);
	}
}

export class NonPartnerRestrictedLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<NonPartnerRestricted />
			</UnauthedLayout>
		);
	}
}

export class MPAAWarningLayout extends Component {
	render() {
		return (
			<AuthedLayout location={this.props.location}>
				<MPAAWarning {...this.props} />
			</AuthedLayout>
		);
	}
}

export class FeedbackLayout extends Component {
	render() {
		return (
			<AuthedLayout location={this.props.location}>
				<Feedback {...this.props} />
			</AuthedLayout>
		);
	}
}

export class StudyLayout extends Component {
	render() {
		return (
			<AuthedLayout location={this.props.location}>
				<Study {...this.props} />
			</AuthedLayout>
		);
	}
}

export class HomeLayout extends Component {
	render() {
		return (
			<AuthedLayout location={this.props.location}>
				<Home {...this.props} />
			</AuthedLayout>
		);
	}
}

export class MobileRedirectLayout extends Component {
	render() {
		return (
			<UnauthedLayout location={this.props.location}>
				<MobileRedirect {...this.props} />
			</UnauthedLayout>
		);
	}
}


// WEBPACK FOOTER //
// ./src/layouts/layouts.js